import { omit } from 'lodash-es';

import { BASE_SIZE } from '../constant';

export const TABLE_ROW_SIZE = omit(BASE_SIZE, 'XS', 'XL');
export const TABLE_ROW_SIZE_HEIGHT = {
  [TABLE_ROW_SIZE.SM]: 22,
  [TABLE_ROW_SIZE.MD]: 44,
  [TABLE_ROW_SIZE.LG]: 72,
} as const;
